import UIPopover from 'UIComponents/tooltip/UIPopover';
import EventBoundary from './EventBoundary';
export default EventBoundary(UIPopover);